// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"a1abba21","568":"a1abba21"}[chunkId] + ".chunk.css";
};